import React, { useEffect } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';
import { useLocation } from 'react-router-dom'; // 경로 감시용
const ProjectList = ({
  dashboard,
  apiRef,
  columns,
  rows,
  error,
  loading,
  handleRowClick,
}) => {
  const [pageSize, setPageSize] = React.useState(20);
  const [height, setHeight] = React.useState('calc(100vh - 325px)');
  const [gridState, setGridState] = React.useState(() => {
  const saved = sessionStorage.getItem('datagrid-pro-state');
    return saved ? JSON.parse(saved) : {
      filter: { items: [], quickFilterValues: [] },
      sort: [],
      pagination: { page: 0, pageSize: 20 }
    };
  });
  const saveState = (key, value) => {
    const newState = { ...gridState, [key]: value };
    setGridState(newState);
    sessionStorage.setItem('datagrid-pro-state', JSON.stringify(newState));
  };
  
  const location = useLocation();

// 메뉴(경로)가 바뀌면 상태 초기화 여부 결정
  useEffect(() => {
    const lastPath = sessionStorage.getItem('last-path');
    
    // 이전 경로와 현재 경로가 다르면 세션 초기화
    if (lastPath && lastPath !== location.pathname) {
      sessionStorage.removeItem('datagrid-pro-state');
      // 초기 상태로 리셋하고 싶다면 여기서 setGridState를 호출하세요.
      setGridState({
        filter: { items: [], quickFilterValues: [] },
        sort: [],
        pagination: { page: 0, pageSize: 20 }
      });
    }

    // 현재 경로 저장
    sessionStorage.setItem('last-path', location.pathname);
  }, [location.pathname]);

  React.useEffect(() => {
    if (dashboard) {
      setHeight('340px');
    }
  }, [dashboard]);

  return (
    <div style={{ display: 'flex', height: height }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          paginationModel={gridState.pagination} 
          onPaginationModelChange={(newModel) => saveState('pagination', newModel)}
          filterModel={gridState.filter}
          onFilterModelChange={(newModel) => saveState('filter', newModel)}          
          sortModel={gridState.sort}
          onSortModelChange={(newModel) => saveState('sort', newModel)}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '프로젝트 리스트',
              showQuickFilter: true, // 퀵 필터 활성화 확인
              quickFilterProps: { debounceMs: 500 },
             },
          }}
          density="compact"
          loading={loading}
          onRowClick={handleRowClick}
          onPageChange={(newPage) => {
            const newPagination = { ...gridState.pagination, page: newPage };
            saveState('pagination', newPagination);
          }}
          onPageSizeChange={(newSize) => {
            const newPagination = { ...gridState.pagination, pageSize: newSize };
            saveState('pagination', newPagination);
          }}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          page={gridState.pagination?.page || 0}
          pageSize={gridState.pagination?.pageSize || 20}
        />
      </div>
    </div>
  );
};

export default ProjectList;
